module.exports = __webpack_public_path__ + "static/media/shape-small-noimage.f39a8715.svg";